export default __webpack_public_path__ + "static/media/Regle-du-Marathon-du-Court-Metrage-d-Halloween-2022.0becb65a.pdf";